import { Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { SignupPromptService } from '../../core/services/signup-prompt.service';
import { IconComponent } from '../../shared/components/icon/icon.component';
import { RevealDirective } from '../../shared/directives/reveal.directive';

/**
 * PPC/marketing landing page for Wanted Saddle acquisition ad groups —
 * explains the "reverse search" concept to buyers who didn't find what
 * they wanted browsing /shop. Public — no guard.
 */
@Component({
  selector: 'app-want-a-saddle',
  standalone: true,
  imports: [RouterLink, IconComponent, RevealDirective],
  templateUrl: './want-a-saddle.component.html',
})
export class WantASaddleComponent {
  private readonly router = inject(Router);
  private readonly signupPromptService = inject(SignupPromptService);
  private readonly authService = inject(AuthService);

  startWantedAd(): void {
    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/account/wanted-ads/new']);
      return;
    }
    this.signupPromptService.show(
      'Create a free account to post what you’re looking for — it only takes a minute.',
    );
  }
}
